import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocationModel } from 'common/models/page-models/Location/location-data-model';



import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { LocationFormWidgetService } from 'common/widget/location/location-form-widget.service';



@Injectable({
    providedIn: 'root'
})
export class LocationFormResolver extends FormResolverService<LocationModel> {
    constructor(
        protected fs: LocationFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override modifyResponseData(dataModel) {
        let data;
        if (!dataModel.hasOwnProperty('id')) {
            data = {
                name: dataModel.cityName,
                id: dataModel.cityID
            }
        } else {
            data = dataModel;
        }

        return data;
    }
}
